module.exports = __webpack_public_path__ + "static/fonts/iconfont.be0cb2f.ttf";